import styled, { css } from 'styled-components'
import { ProductCard } from '@sainsburys-tech/bolt'

const getCarouselWidth = (numberOfProducts, multiple) => `calc(${numberOfProducts * multiple}%)`

export const Carousel = styled.div`
  display: grid;
  grid-auto-flow: column;
  column-gap: ${(props) => props.theme.size.spacing.lg};
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  height: 100%;
  min-width: ${(props) => getCarouselWidth(props.numberOfProducts, 55)};

  ${(props) =>
    props.isHighlighted &&
    css`
      font-weight: ${props.theme.font.weight.bold};

      img {
        border: 2px solid ${props.theme.color.monochrome.black};
      }
    `}

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    min-width: ${(props) => getCarouselWidth(props.numberOfProducts, 65)};
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    min-width: ${(props) => getCarouselWidth(props.numberOfProducts, 40)};
    // Below is required if there is only 1 product in carousel
    ${(props) =>
      props.numberOfProducts === 1 &&
      css`
        grid-template-columns: 38% 1fr 1fr;
      `}
  }
`

export const SliderWrapper = styled.div`
  text-decoration: none;
  justify-content: flex-start;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
`

export const StyledProductCardAlt = styled(ProductCard)`
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    padding: 15px 0;
  }
`

export const StyledProductCard = styled(StyledProductCardAlt)`
  max-width: 183px;
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    max-width: 232px;
  }
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    max-width: 482px;
  }

  ${(props) =>
    props.isHighlighted &&
    css`
      font-weight: ${props.theme.font.weight.bold};

      img {
        border: ${props.theme.size.border.width.base} solid ${props.theme.color.monochrome.black};
      }
    `}
`
